import { render, staticRenderFns } from "./cell-translation-job-status.vue?vue&type=template&id=385dc4e7&scoped=true"
import script from "./cell-translation-job-status.ts?vue&type=script&lang=ts&external"
export * from "./cell-translation-job-status.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-translation-job-status.vue?vue&type=style&index=0&id=385dc4e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385dc4e7",
  null
  
)

export default component.exports